import { CalendarBaseModel } from '../core/models/calendar-base.model';
import { CalendarModel } from '../core/models/calendar.model';
import { CheckboxModel } from '../core/models/checkbox.model';
import { ChipsModel } from '../core/models/chips.model';
import { InputModel } from '../core/models/input.model';
import { RadioCardListModel } from '../core/models/radio-card-list.model';
import { RadioCardModel } from '../core/models/radio-card.model';
import { RadioListModel } from '../core/models/radio-list.model';
import { RadioModel } from '../core/models/radio.model';
import { SelectModel } from '../core/models/select.model';
import { Numbers, commondSelectOptionsList } from './constants';
import { getFutureDate, setBtnTooltip, setCheckboxModel, setInputModel, setRadioCardModel, setRadioModel,
  setSelectModel, setSelectOptions, setSelectValue } from './labels.utils';

export const setDateFormConfig = (linkFormValue: string): Record<string, any> => {
    return {
        start: new CalendarModel({
            linkFormPath: [linkFormValue, 'dateStart'],
            minDate: getFutureDate(1),
            required: true,
            requiredText: 'form1.date-init.error',
            placeholder: 'form1.date-init',
            value: ''
        }),
        end: new CalendarModel({
            linkFormPath: [linkFormValue, 'dateEnd'],
            maxDate: new Date('1-30-2021'),
            required: true,
            requiredText: 'form1.date-end.error',
            placeholder: 'form1.date-end',
            value: ''
        })
    };
};

export const setDateLegalFormConfig = (linkFormValue: string): Record<string, any> => {
  return {
    start: new CalendarModel({
      linkFormPath: [ linkFormValue, 'dateStart'],
      minDate: getFutureDate(1),
      required: true,
      requiredText: 'form1.date-init.error',
      placeholder: 'form1.date-init',
      value: getFutureDate(1)
    }),
    end: new CalendarModel({
      linkFormPath: [linkFormValue, 'dateEnd'],
      maxDate: new Date('1-30-2021'),
      readonlyInput: true,
      required: true,
      requiredText: 'form1.date-end.error',
      placeholder: 'form1.date-end',
      value: getFutureDate(0, 1)
    })
  };
};


/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
export const getNumberOfInsured: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {
  return new SelectModel(
    setSelectModel([linkFormValue, 'numberOfInsured'],
      setSelectValue('form1.number-insured', 'form1.number-insured.error', 'label_size_7'),
      setSelectOptions('', '', commondSelectOptionsList)
    )
  );
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
export const getInsuredOlderThan70years: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {
  return new SelectModel(
  setSelectModel([linkFormValue, 'insuredOlderThan70years'],
    setSelectValue('form1.old-70', 'form1.old-70.error', 'label_size_7'),
    setSelectOptions('', '', commondSelectOptionsList),
    setBtnTooltip('icon icon-info', 'form1.old-70-tooltip')
  ));
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
export const getInsuredsPlayRiskSports: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {

  let description = '';

  if (linkFormValue ===  'individualTravelAsistance') {
    description = 'form1.risk-play';
  } else {
    description = 'form3.risk-play';
  }

  return new SelectModel(
  setSelectModel([linkFormValue, 'insuredsPlayRiskSports'],
    setSelectValue(description, undefined, 'label_size_7'),
    setSelectOptions('', '', commondSelectOptionsList),
    setBtnTooltip('icon icon-info', 'form1.risk-play-tooltip')
  ));
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de checkbox
 */
export const getAllInsuredSameFamiliarUnit: (linkFormValue: string) => CheckboxModel = (linkFormValue: string): CheckboxModel => {
  return new CheckboxModel(
    setCheckboxModel([linkFormValue, 'allInsuredSameFamiliarUnit'],
    'form1.family-unit-label', false, undefined,
    setBtnTooltip('icon icon-info', 'form1.family-unit-tooltip')
  ));
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de checkbox
 */
export const getCurrentlyTraveling: (linkFormValue: string) => CheckboxModel = (linkFormValue: string): CheckboxModel => {
  return new CheckboxModel(setCheckboxModel([linkFormValue, 'currentlyTraveling'], 'form1.travel-72', false));
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getCodePromotional: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'codePromotional'],
    label: 'form1.promotional',
    value: ''
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de checkbox
 */
export const getHasCodeDerogation: (linkFormValue: string) => CheckboxModel = (linkFormValue: string): CheckboxModel => {
  return new CheckboxModel(setCheckboxModel([linkFormValue, 'hasCodeDerogation'],
  'form1.repeal', false));
};

export const getHasPetsInsurance: (linkFormValue: string) => CheckboxModel = (linkFormValue: string): CheckboxModel => {
  return new CheckboxModel(setCheckboxModel([linkFormValue, 'hasPetsInsurance'],
  'form1.petInsureds-checkBox', false));
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de chip
 */
export const getDerogationCodes: (linkFormValue: string) => ChipsModel = (linkFormValue: string): ChipsModel => {
  return new ChipsModel({
    linkFormPath: [linkFormValue, 'derogationCodes'],
    input: new InputModel({
      label: 'form1.insertCodeVerification'
    }),
    codes: [],
    requiredText: 'form1.insertCodeVerification.error'
  });
};

/**
 * @description funcion para obtener el tipo de asegurado
 * @param linkFormValue foumulario que se usa
 * @returns objeto
 */
export const getTypeOwner = (linkFormValue) => {
  return {
    linkFormPath: [linkFormValue, 'insuredData', 'typeOwner'],
    value: 'Particular'
  };
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getParticular = (linkFormValue) => {
  return {
    name: new InputModel({
      linkFormPath: [linkFormValue, 'insuredData', 'particular', 'name'],
      label: 'form1.particular.name',
      required: true,
      requiredText: 'form1.particular.name.error'
    })
  };
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select y de input
 */
export const getBussines = (linkFormValue) => {
  return {
    companySector: new SelectModel(
      setSelectModel([linkFormValue, 'insuredData', 'bussines', 'companySector'],
        setSelectValue('form1.bussines.company-selector',
          'form1.bussines.company-selector.error'),
        setSelectOptions('', '', [{ name: 'Construccion', id: Numbers.number0 },
        { name: 'Hostelería', id: Numbers. number1 }, { name: 'Turismo', id: Numbers.number2 }])
      )
    ),
    direction: new InputModel({
      linkFormPath: [linkFormValue, 'insuredData', 'bussines', 'direction'],
      label: 'form1.bussines.direction-selector',
      required: true,
      requiredText: 'form1.bussines.direction-selector.error'
    })
  };
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
export const getDocumentType: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {
  return new SelectModel(
    setSelectModel([linkFormValue, 'insuredData', 'documentType'],
      setSelectValue('form1.bussines.document-selector',
        'form1.bussines.company-selector.error'),
      setSelectOptions('', '', [{ name: 'NIF', id: Numbers.number1 },
        { name: 'NIE', id: Numbers.number3 },
        { name: 'Pasaporte', id: Numbers.number4 }]
      )
    )
  );
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
export const getListDataDocumentType: () => SelectModel = (): SelectModel => {
  return new SelectModel(
    setSelectModel(['documentType'],
      setSelectValue('form1.listdata.document-type', 'form1.default-error'),
      setSelectOptions('', '',  [{ name: 'NIF', id: Numbers.number1 },
      { name: 'NIE', id: Numbers.number3 },
      { name: 'Pasaporte', id: Numbers.number4 }])
    )
  );
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getDocumentNumber: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'documentNumber'],
    label: 'form1.doc-number',
    maxlength: '15',
    required: true,
    requiredText: 'form1.default-error',
    maxlengthText: 'form1.default-maxlenght-error'
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getListDataDocumentNumber: () => InputModel = (): InputModel => {
  return new InputModel({
    linkFormPath: ['documentNumber'],
    label: 'form1.listdata.document-number',
    value: '',
    required: true,
    requiredText: 'form1.default-error',
    maxlengthText: 'form1.default-maxlenght-error'
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getListDataName: () => InputModel = (): InputModel => {
  return new InputModel({
    linkFormPath: ['name'],
    label: 'form1.listdata.name',
    value: '',
    required: true,
    requiredText: 'form1.default-error'
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getEmName: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'emergencyContact', 'name'],
    label: 'form1.emergencyContact.name',
    requiredText: 'form1.default-error'
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getFirstSurname: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'firstSurname'],
    label: 'form1.first-surname',
    required: false,
    requiredText: 'form1.default-error'
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @returns modelo de input
 */
export const getListDataFirstSurname: () => InputModel = (): InputModel => {
  return new InputModel({
    linkFormPath: ['firstSurname'],
    label: 'form1.listdata.first-surname',
    value: '',
    required: true,
    requiredText: 'form1.default-error'
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getEmFirstSurname: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'emergencyContact', 'firstSurname'],
    label: 'form1.emergencyContact.first-surname',
    requiredText: 'form1.default-error'
  });
};

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
export const getSeccondSurname: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'secondSurname'],
    label: 'form1.second-surname',
    required: false
  });
};


export const commonParticularDataLegal = (linkFormPath: string, date: CalendarBaseModel, typeForm: string) => {
  return {
    numberOfInsured: new SelectModel(
      setSelectModel([linkFormPath, 'numberOfInsured'],
        setSelectValue(`${typeForm}.number-insured`, `${typeForm}.number-insured.error`, 'label_size_7'),
        setSelectOptions('', '', [{ name: '0', id: Numbers.number0 }, { name: '1', id: Numbers.number1 },
        { name: '2', id: Numbers.number2 }, { name: '3', id: Numbers.number3 }])
      )
    ),
    guaranteeLimitOfMedicalExpenses: new SelectModel(
      setSelectModel([ linkFormPath, 'guaranteeLimitOfMedicalExpenses' ],
      setSelectValue(`${typeForm}.limit-guarantee`, `${typeForm}.limit-guarantee.error`, 'label_size_7'),
      setSelectOptions('', '', [ { name: '18.000', id: Numbers.number0 }, { name: '30.000', id: Numbers.number1 },
      { name: '120.000', id: Numbers.number2 }, { name: '200.000', id: Numbers.number3 } ])
      )
    ),
    // insuranceTime attribute: Temporal, Anual o Larga Estancia
    insuranceTime: new RadioListModel( {
      linkFormPath: [ linkFormPath, 'insuranceTime' ],
      radioList: [
        new RadioModel(setRadioModel(`${typeForm}.duration-temporal`, `${typeForm}.duration-temporal-text`, true)),
        new RadioModel(setRadioModel(`${typeForm}.duration-anual`, `${typeForm}.duration-anual-text`)),
        new RadioModel(setRadioModel(`${typeForm}.duration-long`, `${typeForm}.duration-long-text`))
      ]
    } ),
    // Country Origin attribute
    countryOrigin: new SelectModel(
      setSelectModel([ linkFormPath, 'countryOrigin' ],
      setSelectValue(`${typeForm}.country-origin`, `${typeForm}.country-origin.error`, 'label_size_7'),
      setSelectOptions('', '', [
        { name: 'España', id: Numbers.number0 },
        { name: 'Istanbul', id: Numbers.number1 },
        { name: 'London', id: Numbers.number2 } ])
      )),
    // Country Origin attribute
    countryDestiny: new SelectModel(
      setSelectModel([ linkFormPath, 'countryDestiny' ],
      setSelectValue(`${typeForm}.country-destiny`, `${typeForm}.country-destiny.error`, 'label_size_7'),
      setSelectOptions('', '', [
        { name: 'España', id: Numbers.number19001 },
        { name: 'Mundo (Incluido Estados Unidos)', id: Numbers.number19004 },
        { name: 'Mundo (Excluido Estados Unidos)', id: Numbers.number19007 },
        { name: 'Europa y Ribereños Mediterráneo', id: Numbers.number19002 }
      ], [
        { label: 'New York', value: { name: 'New York', code: 'NY' } },
        { label: 'Rome', value: { name: 'Rome', code: 'RM' } },
        { label: 'London', value: { name: 'London', code: 'LDN' } },
        { label: 'Istanbul', value: { name: 'Istanbul', code: 'IST' } },
        { label: 'Paris', value: { name: 'Paris', code: 'PRS' } }
      ])
      )
    ),
    date,
    // Temporal, Anual, Larga Estancia
    insuranceType: new RadioCardListModel( {
      linkFormPath: [ linkFormPath, 'insuranceType' ],
      radioCardList: [
        new RadioCardModel(setRadioCardModel(Numbers.number0, `${typeForm}.coverage0`)),
        new RadioCardModel(setRadioCardModel(Numbers.number1, `${typeForm}.coverage1`)),
        new RadioCardModel(setRadioCardModel(Numbers.number2, `${typeForm}.coverage2`))
      ]
    })
  };
};

export const commonLegalInsuredData = (linkFormPath: string) => {
  return {
    // document number
    documentNumber: new InputModel( setInputModel( [linkFormPath, 'insuredData', 'documentNumber'], 'form1.doc-number',
    { maxlength: '15', requiredText: 'form1.default-error', maxlengthText: 'form1.default-maxlenght-error' }, true)),
    // Surname 1
    firstSurname: new InputModel(setInputModel([linkFormPath, 'insuredData', 'firstSurname'], 'form1.first-surname',
    { requiredText: 'form1.default-error'})),
    // Surname 2
    secondSurname: new InputModel(setInputModel([linkFormPath, 'insuredData', 'secondSurname'], 'form1.second-surname', {})),
    // email
    email: new InputModel( setInputModel([linkFormPath, 'insuredData', 'email'], 'form1.email',
    { requiredText: 'form1.default-error', emailError: 'form1.default-email-error' }, true)),
    // prefix
    prefix: new SelectModel(
      setSelectModel([linkFormPath, 'insuredData', 'prefix'],
      setSelectValue('form1.prefix', 'form1.default-error'),
      setSelectOptions('España (+34)', 'España (+34)', [])
    )),
    // Telephone
    telephone: new InputModel( setInputModel([linkFormPath, 'insuredData', 'telephone'], 'form1.telephone',
    { requiredText: 'form1.default-error', maxlength: '9', maxlengthText: 'form1.default-maxlenght-error', onlynumberError: 'form1.default-onlynum-error'}, true)),
    // direction
    direction: new InputModel( setInputModel( [linkFormPath, 'insuredData', 'direction'], 'form1.direction',
    {requiredText: 'form1.default-error'}, true)),
    // postalCode
    postalCode: new InputModel( setInputModel([linkFormPath, 'insuredData', 'postalCode'], 'form1.postalcode',
    { requiredText: 'form1.default-error', cpError: 'form1.default-cp-error', maxlength: '5'}, true)),
    // Municipality
    municipality: new SelectModel(
      setSelectModel([linkFormPath, 'insuredData', 'municipality'],
        setSelectValue('form1.municipality', 'form1.default-error'),
        setSelectOptions('', '', [])
      )
    ),
    // country
    country: new SelectModel(
      setSelectModel([linkFormPath, 'insuredData', 'country'],
        setSelectValue('form1.country', 'form1.default-error'),
        setSelectOptions('España', 'España', [{ name: 'España', id: Numbers.number0 },
        { name: 'Rome', id: Numbers.number1 }, { name: 'London', id: Numbers.number2 }])
      )
    )
  };
};
